export default __webpack_public_path__ + "static/hero-image-3db33f3687fee7da789a92eb9d581212.jpg";